// import { enableProdMode, provideZoneChangeDetection,NgZone } from '@angular/core';
// import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
// // import { provideHighcharts } from 'highcharts-angular';

// import { AppModule } from './app/app.module';
// import { environment } from './environments/environment';
// import { provideLegacyChangeDetection } from './app/providers/legacy-change-detection.provider';

// // import './app/instrument/instrument'

// if (environment.production) {
//   enableProdMode();
// }

// // DevTools blocking is handled only by /assets/js/devtools-guard.js in index.html

// function loadMiddlewareRum(): Promise<void> {
//   return new Promise((resolve) => {
//     const s = document.createElement('script');
//     s.src = 'https://cdnjs.middleware.io/browser/libs/0.0.2/middleware-rum.min.js';
//     s.crossOrigin = 'anonymous';
//     s.async = true;

//     s.onload = () => {
//       const mw = (window as any).Middleware;

//       if (!mw) {
//         resolve();
//         return;
//       }

//       mw.track({
//         serviceName: 'bot-uat-frontend',
//         projectName: 'bot-uat-frontend',
//         // accountKey provided at deploy time — do not hardcode secrets in source
//         target: 'https://bcqrb.middleware.io',
//         tracePropagationTargets: [/.*/],
//         defaultAttributes: {
//           'app.version': '1.0.0',
//         },
//       });

//       resolve();
//     };

//     s.onerror = () => resolve();

//     document.head.appendChild(s);
//   });
// }

// platformBrowserDynamic().bootstrapModule(AppModule, { 
// applicationProviders: [
// provideZoneChangeDetection(),
// provideLegacyChangeDetection(),
// // provideHighcharts({ instance: () => import('highcharts/esm/highcharts').then(m => m.default) }),
// ],
// })
//    .then((moduleRef) => {
//     const ngZone = moduleRef.injector.get(NgZone);

//     ngZone.runOutsideAngular(() => {
//       loadMiddlewareRum();
//     });
//   })
//   .catch((err) => console.error(err));

import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
// import { provideHighcharts } from 'highcharts-angular';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { provideLegacyChangeDetection } from './app/providers/legacy-change-detection.provider';

// import './app/instrument/instrument'

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule, { 
applicationProviders: [
provideZoneChangeDetection(),
provideLegacyChangeDetection(),
// provideHighcharts({ instance: () => import('highcharts/esm/highcharts').then(m => m.default) }),
],
})
  .catch(err => console.error(err));

